import { useLayoutEffect, useRef, useState } from 'react';

const VIEWPORT_MARGIN = 8;

// Floating elements are centred on the selection with translateX(-50%):
// clamp the centre point so the element never overflows the viewport.
export default function useClampedLeft(left: number) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [clampedLeft, setClampedLeft] = useState(left);

  useLayoutEffect(() => {
    const width = ref.current?.offsetWidth || 0;
    const half = width / 2;
    const minLeft = window.scrollX + VIEWPORT_MARGIN + half;
    const maxLeft = window.scrollX + window.innerWidth - VIEWPORT_MARGIN - half;

    setClampedLeft(
      Math.min(Math.max(left, minLeft), Math.max(minLeft, maxLeft)),
    );
  }, [left]);

  return { ref, clampedLeft };
}
